/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
import { environment } from './../environments/environment';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    // the App ID representing the studio app in Azure App Registration
    clientId: 'e0b834d0-80f4-4d4f-a3cc-ffffa07406cc',
    // using orgainization means multi-tenant
    authority: 'https://login.microsoftonline.com/315f9425-6d72-4caa-acd1-8b64d3a0ea03',
    redirectUri: environment.authRedirectUri,
    postLogoutRedirectUri: environment.authPostLogoutRedirectUri
  },
  cache: {
    // Configures cache location. 'sessionStorage' is more secure, but 'localStorage' gives you SSO between tabs.
    cacheLocation: BrowserCacheLocation.LocalStorage,
    // Set this to 'true' if you are having issues on IE11 or Edge
    storeAuthStateInCookie: isIE
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        // console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  backendApi: {
    endpoint: '/api',
    scopes: ['api://fd621a97-99a3-4780-80d0-0492ed9aa6ef/.default'],
  },
  backendReports: {
    endpoint: '/reports',
    scopes: ['api://fd621a97-99a3-4780-80d0-0492ed9aa6ef/.default'],
  }
};
